import {
  pageEffectiveWork,
  pageWorkPoints,
  listDataComplete,
  completeWorkOrderPageList,
  satisfiedPageList,
  dissatisfiedPageList,
  rollbackOverThreePageList,
  excellentCasePageList,
  benifitsPageList
} from '@/api/DataCenter/index'
import { SatisfactionPageList } from '@/api/Todo/satisfaction'
const handleStatus = (ctxStatus, ctxConfig) => {
  return ctxConfig.find(item => item.value === ctxStatus)
}
// 数据中心 主列表
const DataCenterColumnsTemplate = [
  {
    title: 'ERP编号',
    key: 'erpId',
    dataIndex: 'erpId',
    width: 120
  },
  {
    title: '姓名',
    key: 'realName',
    dataIndex: 'realName',
    width: 120
  },
  {
    title: '当期坐班总时长（时）',
    key: 'totalWorkingSeconds',
    dataIndex: 'totalWorkingSeconds',
    width: 160,
    sorter: true
  },
  {
    title: '当期完成工单数',
    key: 'totalCompleteWorkNum',
    dataIndex: 'totalCompleteWorkNum',
    width: 140,
    sorter: true
  },
  {
    title: '当期有效工单数',
    key: 'totalEffectiveWorkNum',
    dataIndex: 'totalEffectiveWorkNum',
    width: 140,
    sorter: true,
    slots: { customRender: 'totalEffectiveWorkNum' }
  },
  {
    title: '当期累计积分数',
    key: 'totalPointsNum',
    dataIndex: 'totalPointsNum',
    width: 140,
    sorter: true,
    slots: { customRender: 'totalPointsNum' }
  },
  {
    title: '当期完善信息数',
    key: 'totalCompleteDataNum',
    dataIndex: 'totalCompleteDataNum',
    width: 140,
    sorter: true,
    slots: { customRender: 'totalCompleteDataNum' }
  },
  {
    title: '当期满意度评价',
    dataIndex: 'satisfactionEvaluation',
    width: 140,
    sorter: true,
    slots: { customRender: 'satisfactionEvaluation' }
  }
]

const DataCenterColumns = [
  {
    title: 'ERP编号',
    key: 'erp_id',
    dataIndex: 'erp_id',
    width: 120
  },
  {
    title: '姓名',
    key: 'real_name',
    dataIndex: 'real_name',
    width: 120
  },
  {
    title: '岗位',
    key: 'job_name',
    dataIndex: 'job_name',
    width: 120
  },
  {
    title: '当期坐班总时长（时）',
    key: 'working_hours',
    dataIndex: 'working_hours',
    width: 160,
    sorter: true,
    sortOrder: false,
    slots: { customRender: 'working_hours' }
  },
  {
    title: '完成工单数',
    key: 'complete_work_order_cnt',
    dataIndex: 'complete_work_order_cnt',
    width: 140,
    sorter: true,
    sortOrder: false,
    slots: { customRender: 'complete_work_order_cnt' }
  },
  {
    title: '满意数',
    key: 'satisfied_cnt',
    dataIndex: 'satisfied_cnt',
    width: 140,
    sorter: true,
    sortOrder: false,
    slots: { customRender: 'satisfied_cnt' }
  },
  {
    title: '不满意数',
    key: 'dissatisfied_cnt',
    dataIndex: 'dissatisfied_cnt',
    width: 140,
    sorter: true,
    sortOrder: false,
    slots: { customRender: 'dissatisfied_cnt' }
  },
  {
    title: '回滚超三次工单数',
    key: 'rollback_over_three_cnt',
    dataIndex: 'rollback_over_three_cnt',
    width: 160,
    sorter: true,
    sortOrder: false,
    slots: { customRender: 'rollback_over_three_cnt' }
  },
  {
    title: '优秀案例数',
    key: 'excellent_case_cnt',
    dataIndex: 'excellent_case_cnt',
    width: 140,
    sorter: true,
    sortOrder: false,
    slots: { customRender: 'excellent_case_cnt' }
  },
  {
    title: '效益金额',
    key: 'benifits',
    dataIndex: 'benifits',
    width: 140,
    sorter: true,
    sortOrder: false,
    slots: { customRender: 'benifits' }
  }
]

// 完成工单数
const CompleteWorkOrder = [
  {
    title: '工单ID',
    key: 'workOrderId',
    dataIndex: 'workOrderId',
    slots: { customRender: 'workOrderId' }
  },
  {
    title: '工单类型',
    key: 'workOrderTypeName',
    dataIndex: 'workOrderTypeName'
  },
  {
    title: '生成时间',
    key: 'createdAt',
    dataIndex: 'createdAt',
    slots: { customRender: 'createdAt' }
  },
  {
    title: '完成时间',
    key: 'completeTime',
    dataIndex: 'completeTime',
    slots: { customRender: 'completeTime' }
  },
  {
    title: '是否达到自动完成条件',
    key: 'whetherAutoComplete',
    dataIndex: 'whetherAutoComplete',
    slots: { customRender: 'whetherAutoComplete' }
  },
  {
    title: '是否有痕迹',
    key: 'whetherTrace',
    dataIndex: 'whetherTrace',
    slots: { customRender: 'whetherTrace' }
  }
]

// 满意数
const SatisfactionNumbers = [
  {
    title: '工单ID',
    key: 'workOrderId',
    dataIndex: 'workOrderId',
    slots: { customRender: 'workOrderId' }
  },
  {
    title: '工单类型',
    key: 'workOrderTypeName',
    dataIndex: 'workOrderTypeName'
  },
  {
    title: '生成时间',
    key: 'createdAt',
    dataIndex: 'createdAt',
    slots: { customRender: 'createdAt' }
  },
  {
    title: '完成时间',
    key: 'completeTime',
    dataIndex: 'completeTime',
    slots: { customRender: 'completeTime' }
  },
  {
    title: '满意数',
    key: 'satisfiedCnt',
    dataIndex: 'satisfiedCnt',
    slots: { customRender: 'satisfiedCnt' }
  }
]

// 不满意数
const DissatisfactionNumbers = [
  {
    title: '工单ID',
    key: 'workOrderId',
    dataIndex: 'workOrderId',
    slots: { customRender: 'workOrderId' }
  },
  {
    title: '工单类型',
    key: 'workOrderTypeName',
    dataIndex: 'workOrderTypeName'
  },
  {
    title: '生成时间',
    key: 'createdAt',
    dataIndex: 'createdAt',
    slots: { customRender: 'createdAt' }
  },
  {
    title: '完成时间',
    key: 'completeTime',
    dataIndex: 'completeTime',
    slots: { customRender: 'completeTime' }
  },
  {
    title: '不满意数',
    key: 'dissatisfiedCnt',
    dataIndex: 'dissatisfiedCnt',
    slots: { customRender: 'dissatisfiedCnt' }
  }
]

// 回滚超3次工单数
const RollBackMoreThanThreeWorkOrders = [
  {
    title: '工单ID',
    key: 'workOrderId',
    dataIndex: 'workOrderId',
    slots: { customRender: 'workOrderId' }
  },
  {
    title: '工单类型',
    key: 'workOrderTypeName',
    dataIndex: 'workOrderTypeName'
  },
  {
    title: '生成时间',
    key: 'createdAt',
    dataIndex: 'createdAt',
    slots: { customRender: 'createdAt' }
  },
  {
    title: '完成时间',
    key: 'completeTime',
    dataIndex: 'completeTime',
    slots: { customRender: 'completeTime' }
  },
  {
    title: '处理顺序',
    key: 'dealOrder',
    dataIndex: 'dealOrder'
  }
]

// 优秀案例数
const ExcellentCases = [
  {
    title: '优秀案例ID',
    key: 'excellentCaseId',
    dataIndex: 'excellentCaseId',
    slots: { customRender: 'excellentCaseId' }
  },
  {
    title: '工单ID',
    key: 'workOrderId',
    dataIndex: 'workOrderId',
    slots: { customRender: 'workOrderId' }
  },
  {
    title: '工单类型',
    key: 'workOrderTypeName',
    dataIndex: 'workOrderTypeName'
  },
  {
    title: '上传人',
    key: 'createdByName',
    dataIndex: 'createdByName'
  },
  {
    title: '上传时间',
    key: 'uploadAt',
    dataIndex: 'uploadAt',
    slots: { customRender: 'uploadAt' }
  }
]

// 效益金额
const BenefitAmount = [
  {
    title: '工单ID',
    key: 'workOrderId',
    dataIndex: 'workOrderId',
    slots: { customRender: 'workOrderId' }
  },
  {
    title: '工单类型',
    key: 'workOrderTypeName',
    dataIndex: 'workOrderTypeName'
  },
  {
    title: '生成时间',
    key: 'createdAt',
    dataIndex: 'createdAt'
  },
  {
    title: '完成时间',
    key: 'completeTime',
    dataIndex: 'completeTime'
  },
  {
    title: '收益金额',
    key: 'benefitAmount',
    dataIndex: 'benefitAmount',
    slots: { customRender: 'benefitAmount' }
  }
]

// 有效工单列表
const ValidWorkOrder = [
  {
    title: '工单ID',
    key: 'workOrderId',
    dataIndex: 'workOrderId'
  },
  {
    title: '工单类型',
    key: 'businessType',
    dataIndex: 'businessType',
    slots: {
      customRender: 'businessType'
    }
  },
  {
    title: '工单任务',
    key: 'workOrderTask',
    dataIndex: 'workOrderTask',
    width: 240,
    slots: {
      customRender: 'workOrderTask'
    }
  },
  {
    title: '提醒人',
    key: 'reminder',
    dataIndex: 'reminder',
    slots: {
      customRender: 'reminder'
    }
  },
  {
    title: '操作',
    key: 'handle',
    dataIndex: 'handle',
    fixed: 'right',
    width: 104,
    slots: { customRender: 'handle' }
  }
]

// 累计积分列表
const CumulativePoints = [
  {
    title: '工单ID',
    key: 'workOrderId',
    dataIndex: 'workOrderId'
  },
  {
    title: '工单类型',
    key: 'businessType',
    dataIndex: 'businessType',
    slots: {
      customRender: 'businessType'
    }
  },
  {
    title: '工单任务',
    key: 'workOrderTask',
    dataIndex: 'workOrderTask',
    width: 240,
    slots: {
      customRender: 'workOrderTask'
    }
  },
  {
    title: '提醒人',
    key: 'reminder',
    dataIndex: 'reminder',
    slots: {
      customRender: 'reminder'
    }
  },
  {
    title: '积分',
    key: 'pointsNum',
    dataIndex: 'pointsNum'
  },
  {
    title: '操作',
    key: 'handle',
    dataIndex: 'handle',
    slots: { customRender: 'handle' }
  }
]

const FillInformation = [
  {
    title: '患者ID',
    key: 'ucPatientId',
    dataIndex: 'ucPatientId',
    width: 250
  },
  {
    title: '患者姓名',
    key: 'patientName',
    dataIndex: 'patientName'
  },
  {
    title: '完善类型',
    key: 'operationTypeListStr',
    dataIndex: 'operationTypeListStr',
    width: 250
  },
  {
    title: '完善数量',
    key: 'sumRealNum',
    dataIndex: 'sumRealNum'
  },
  {
    title: '操作',
    key: 'handle',
    dataIndex: 'handle',
    slots: { customRender: 'handle' }
  }
]

const SatisfactionEvaluation = [
  {
    title: '满意度ID',
    dataIndex: 'id',
    width: 150
  },
  {
    title: '工单ID',
    dataIndex: 'workOrderList',
    width: 150,
    slots: { customRender: 'workOrderList' }
  },
  {
    title: '患者ID',
    dataIndex: 'ucPatientId',
    width: 150
  },
  {
    title: '患者姓名',
    dataIndex: 'patientName',
    width: 150
  },
  {
    title: '评价结果',
    dataIndex: 'evaluateResult',
    width: 150,
    customRender({ text }) {
      const { label } = handleStatus(text, EaluateResultsMap) || {}
      return label
    }
  },
  {
    title: '创建时间',
    dataIndex: 'createdAt',
    width: 150,
    sorter: true
  },
  {
    title: '评价时间',
    dataIndex: 'evaluateTime',
    width: 150,
    sorter: true
  }
]
const DetailDriveConfigTemplate = {
  totalEffectiveWorkNum: {
    label: '有效工单',
    column: ValidWorkOrder,
    fetchApi: pageEffectiveWork,
    exportUrl: '/health-doctor-assistant/doctor-assistant/data-analyse/excelEffectiveWork',
    onlyPatientInfo: false,
    searchParams: ['workOrderId', 'businessType']
  },
  totalPointsNum: {
    label: '累计积分',
    column: CumulativePoints,
    fetchApi: pageWorkPoints,
    exportUrl: '/health-doctor-assistant/doctor-assistant/data-analyse/excelWorkPoints',
    onlyPatientInfo: false,
    searchParams: ['workOrderId', 'businessType']
  },
  totalCompleteDataNum: {
    label: '完善信息',
    column: FillInformation,
    fetchApi: listDataComplete,
    exportUrl: '/health-emr/doctor-assistant/excelDataComplete',
    onlyPatientInfo: true,
    searchParams: ['ucPatientId', 'patientName']
  },
  satisfactionEvaluation: {
    label: '满意度评价',
    column: SatisfactionEvaluation,
    fetchApi: SatisfactionPageList,
    exportUrl: '/health-doctor-assistant/satisfactionEvaluation/list/export',
    onlyPatientInfo: false,
    searchParams: [
      'id',
      'workOrderId',
      'ucPatientId',
      'patientName',
      'evaluateResult',
      'evaluteTimeRange',
      'evaluateTimeStart',
      'evaluateTimeEnd'
    ]
  }
}

const DetailDriveConfig = {
  complete_work_order_cnt: {
    label: '完成工单数',
    column: CompleteWorkOrder,
    fetchApi: completeWorkOrderPageList,
    onlyPatientInfo: false,
    searchParams: ['workOrderId', 'workOrderType']
  },
  satisfied_cnt: {
    label: '满意数',
    column: SatisfactionNumbers,
    fetchApi: satisfiedPageList,
    onlyPatientInfo: false,
    searchParams: ['workOrderId', 'workOrderType']
  },
  dissatisfied_cnt: {
    label: '不满意数',
    column: DissatisfactionNumbers,
    fetchApi: dissatisfiedPageList,
    onlyPatientInfo: false,
    searchParams: ['workOrderId', 'workOrderType']
  },
  rollback_over_three_cnt: {
    label: '回滚超三次工单数',
    column: RollBackMoreThanThreeWorkOrders,
    fetchApi: rollbackOverThreePageList,
    onlyPatientInfo: false,
    searchParams: ['workOrderId', 'workOrderType']
  },
  excellent_case_cnt: {
    label: '优秀案例数',
    column: ExcellentCases,
    fetchApi: excellentCasePageList,
    onlyPatientInfo: false,
    searchParams: ['workOrderId', 'workOrderType']
  },
  benifits: {
    label: '效益金额',
    column: BenefitAmount,
    fetchApi: benifitsPageList,
    onlyPatientInfo: false,
    searchParams: ['workOrderId', 'workOrderType']
  }
}

const InfoType = [
  {
    label: '基本信息',
    value: 'baseInfoNum'
  },
  {
    label: '病史信息',
    value: 'historyCustomNum'
  },
  {
    label: '生活方式',
    value: 'lifeStyleRecordNum'
  },
  {
    label: '门诊病历',
    value: 'offlineCaseNum'
  },
  {
    label: '检查表单',
    value: 'checkListNum'
  }
]

const handleFillInfoType = key => {
  try {
    const info = InfoType.find(item => item.value === key)
    return info.label
  } catch (error) {
    return '--'
  }
}
// 评价结果
const EaluateResultsMap = [
  {
    value: 5,
    label: '很满意'
  },
  {
    value: 4,
    label: '满意'
  },
  {
    value: 3,
    label: '一般'
  },
  {
    value: 2,
    label: '不满'
  },
  {
    value: 1,
    label: '很不满意'
  }
]

export { DataCenterColumns, DetailDriveConfig, handleFillInfoType, EaluateResultsMap }
